import React from 'react'; // eslint-disable-line
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import _actions from '../../actions';
import AppWrapper from '../../components/structure/AppWrapper';
import AppHeader from '../../components/structure/AppHeader';
import ProjectsList from '../../components/projects/ProjectsList';
import i18n from '../../i18n';
import constants from '../../constants';
import VersionFree from '../../components/structure/VersionFree';

class ProjectsPage extends React.Component {
    constructor(props) {
        super(props);

        this.createNewProject = this.createNewProject.bind(this);
        this.handleDeleteProject = this.handleDeleteProject.bind(this);
    }

    componentDidMount() {
        const tk = localStorage.getItem('AuthToken'); // eslint-disable-next-line
        if (tk == undefined || tk == null) {
            this.props.history.push('/no-access');
        }
        this.props.actions.changeProjects();

        this.props.actions.getTemplates();
        this.props.actions.getProjects();

        document.body.classList.add('projects-page');
    }

    componentDidUpdate(prevProps) {
        // eslint-disable-next-line max-len
        if (this.props.profiles?.data?.id !== '') {

            if (this.props.projects && this.props.projects.newIds) {
                this.props.history.push(`/projects/${this.props.projects.newIds.newProjectId}/general-info/`);
            }

            if (this.props.versions && this.props.versions.isNew) {
                this.props.history.push(`/projects/${this.props.versions.projectId}/general-info`);
            }
        }
        if (prevProps.projects.data?.length !== this.props.projects.data?.length) {
            /***Pendo Installation ***/
            /* eslint-disable */
            let isUnity = localStorage.getItem('IsUnity');
            if (isUnity === 'true') {
                let accountId = localStorage.getItem('UnityOrgId');
                let visitorId = localStorage.getItem('UnityUserId');
                let pendoEmail = localStorage.getItem('UnityEmail');
                let pendoFirstName = localStorage.getItem('FirstName');
                let pendoLastName = localStorage.getItem('LastName');
                let pendoOrgName = localStorage.getItem('ChurchName');
                let pendoFullName = pendoFirstName + ' ' + pendoLastName;
                let pendoWhiteLabel = 'Unity';
                let pendoCreationDate = 'unknown';
                let pendoCity = 'unknown';
                let pendoState = 'unknown';
                let pendoZip = 'unknown';
                if (this.props.projects.data.length > 0) {
                    pendoCreationDate = this.props.projects.data[0].dateCreated;
                    pendoCity = this.props.projects.data[0].latestVersion.churchCity;
                    pendoState = this.props.projects.data[0].latestVersion.churchState;
                    pendoZip = this.props.projects.data[0].latestVersion.churchZip;
                    if (accountId && visitorId) {
                        (function (apiKey) {
                            (function (p, e, n, d, o) {
                                var v, w, x, y, z; o = p[d] = p[d] || {}; o._q = [];
                                v = ['initialize', 'identify', 'updateOptions', 'pageLoad']; for (w = 0, x = v.length; w < x; ++w) (function (m) {
                                    o[m] = o[m] || function () { o._q[m === v[0] ? 'unshift' : 'push']([m].concat([].slice.call(arguments, 0))); };
                                })(v[w]);
                                y = e.createElement(n); y.async = !0; y.src = 'https://cdn.pendo.io/agent/static/' + apiKey + '/pendo.js';
                                z = e.getElementsByTagName(n)[0]; z.parentNode.insertBefore(y, z);
                            })(window, document, 'script', 'pendo');
                            pendo.initialize({
                                visitor: {
                                    id: visitorId,
                                    email: pendoEmail,
                                    AB_FirstName: pendoFirstName,
                                },
                                account: {
                                    id: accountId,
                                    AB_WhiteLabel: pendoWhiteLabel,
                                    AB_CreationDate: pendoCreationDate,
                                    AB_City: pendoCity,
                                    AB_State: pendoState,
                                    AB_Zip: pendoZip,
                                    full_name: pendoFullName.toLowerCase(),
                                    name: pendoOrgName
                                    /* AB_LegacyID: pendolegacyId */
                                }
                            });
                        })('dec509d5-1495-45a2-65a5-0c7a69ff7ecb');
                    }
                }
            }
            else if (isUnity === 'false') {
                let accountId = this.props.profiles.data.organizationId;
                let visitorId = this.props.profiles.data.id;
                let pendoEmail = this.props.profiles.data.email;
                let pendoFirstName = this.props.profiles.data.name;
                let pendoFullName = this.props.profiles.data.name;
                let pendoWhiteLabel = this.props.profiles.data.resellerName;
                let pendolegacyId = this.props.profiles.data.givingChurchId;
                let pendoCreationDate = 'unknown';
                let pendoCity = 'unknown';
                let pendoState = 'unknown';
                let pendoZip = 'unknown';
                let pendoOrgName = 'unknown';

                if (this.props.projects.data.length > 0) {
                    pendoCreationDate = this.props.projects.data[0].dateCreated;
                    pendoCity = this.props.projects.data[0].latestVersion.churchCity;
                    pendoState = this.props.projects.data[0].latestVersion.churchState;
                    pendoZip = this.props.projects.data[0].latestVersion.churchZip;
                    pendoOrgName = this.props.projects.data[0].latestVersion.churchName;

                    if (accountId && visitorId) {
                        (function (apiKey) {
                            (function (p, e, n, d, o) {
                                var v, w, x, y, z; o = p[d] = p[d] || {}; o._q = [];
                                v = ['initialize', 'identify', 'updateOptions', 'pageLoad']; for (w = 0, x = v.length; w < x; ++w) (function (m) {
                                    o[m] = o[m] || function () { o._q[m === v[0] ? 'unshift' : 'push']([m].concat([].slice.call(arguments, 0))); };
                                })(v[w]);
                                y = e.createElement(n); y.async = !0; y.src = 'https://cdn.pendo.io/agent/static/' + apiKey + '/pendo.js';
                                z = e.getElementsByTagName(n)[0]; z.parentNode.insertBefore(y, z);
                            })(window, document, 'script', 'pendo');
                            pendo.initialize({
                                visitor: {
                                    id: visitorId,
                                    email: pendoEmail,
                                    AB_FirstName: pendoFirstName
                                },
                                account: {
                                    id: accountId,
                                    AB_WhiteLabel: pendoWhiteLabel,
                                    AB_CreationDate: pendoCreationDate,
                                    AB_City: pendoCity,
                                    AB_State: pendoState,
                                    AB_Zip: pendoZip,
                                    AB_LegacyID: pendolegacyId,
                                    full_name: pendoFullName.toLowerCase(),
                                    name: pendoOrgName
                                }
                            });
                        })('dec509d5-1495-45a2-65a5-0c7a69ff7ecb');
                    }
                }
            }
            else {
                console.log('IsUnity flag is not set');
            }
           ;  /* eslint-enable */
            /***Pendo Installation ***/
        }
    }

    componentWillUnmount() {
        document.body.classList.remove('projects-page');
    }

    handleDeleteProject(project) {
        this.props.actions.deleteProjectVersion(project);
    }

    createNewProject(name) {
        let isUnity = true;
        if(localStorage.getItem('IsUnity') === 'true'){
          isUnity = true;
        }
        else{
          isUnity = false;
        }

        this.props.actions.createProject(name, isUnity);
    }

    render() {
        return (
            <VersionFree alerts={this.props.alerts}>
                <AppWrapper>
                    <AppHeader>{i18n.t('projects.projects')}</AppHeader>
                    <ProjectsList
                        projectName=""
                        projects={this.props.projects.data}
                        newProjectOnClick={this.createNewProject}
                        deleteProject={this.handleDeleteProject}
                    />
                </AppWrapper>
            </VersionFree>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        ...state,
        ...ownProps,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        actions: bindActionCreators(_actions, dispatch),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ProjectsPage);
